import React from 'react';
import { FilmI } from '../../../interfaces/film';
import { convertStringCapitalizeFirstLetter, DateFormat } from '../../../utils/global';
import TableBase, { Props as TableProps } from './Base';
import { LicenseI } from '../../../interfaces/license';
import { TerritoryI } from '../../../interfaces/territory';
import { TerritoryRights } from '../../../pages/film/components/TerritoryRights';

type Props = TableProps & {
  withAction?(_: any): void;
  dataSource?: any[];
};

const SupplierLicensesTable: React.FC<Props> = ({ dataSource, withAction, ...props }) => {
  const COLUMNS = [
    {
      title: 'Title',
      width: 150,
      render: (film: FilmI) => {
        return (
          <span className="text-uppercase">
            {film.title} {film.titleCN && `《 ${film.titleCN} 》`}{' '}
          </span>
        );
      },
    },
    {
      title: 'License Period',
      width: 200,
      render: (film: any) => {
        return (
          <span className="value">
            {film?.licenseStartDate ? DateFormat(film?.licenseStartDate) : null} -{' '}
            {film?.licenseEndDate ? DateFormat(film?.licenseEndDate) : null}
          </span>
        );
      },
    },
    {
      title: 'Date Of Agreement',
      dataIndex: 'dateOfAgreement',
      width: 200,
      render: (dateOfAgreement: any) => {
        return <span className="value">{dateOfAgreement ? DateFormat(dateOfAgreement) : null}</span>;
      },
    },
    {
      title: 'Year',
      dataIndex: 'year',
      width: 80,
      render: (year: string) => {
        return <span className="value">{year}</span>;
      },
    },
    {
      title: 'Country Of Origin',
      dataIndex: 'countryOfOrigin',
      width: 100,
      render: (countryOfOrigin: string) => {
        return <span className="value">{countryOfOrigin}</span>;
      },
    },
    {
      title: 'Licenses Sold',
      dataIndex: 'soldLicenses',
      width: 300,
      render: (soldLicenses: LicenseI[]) => {
        return soldLicenses?.map((license: LicenseI) => (
          <ul key={license?.id}>
            {license?.licenseTerritories?.map((territory: TerritoryI) => (
              <li key={territory.id}>
                <h2 style={{ fontSize: 14, marginBottom: 5 }}>
                  {territory.name ? convertStringCapitalizeFirstLetter(territory.name as any) : ''}
                </h2>
                <div>
                  {territory?.exclusiveRights && Object.keys(territory?.exclusiveRights).length > 0 && (
                    <div className="item2">
                      <label>Exclusive Rights</label>
                      <TerritoryRights rights={territory?.exclusiveRights} />
                    </div>
                  )}
                  {territory?.nonExclusiveRights && Object.keys(territory?.nonExclusiveRights).length > 0 && (
                    <div className="item2">
                      <label>Non Exclusive Rights</label>
                      <TerritoryRights rights={territory?.nonExclusiveRights} />
                    </div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        ));
      },
    },
  ];

  if (withAction) {
    COLUMNS.push({
      key: 'action',
      width: 50,
      fixed: 'right' as unknown as boolean,
      render(record: any) {
        return withAction(record);
      },
    } as any);
  }
  return <TableBase dataSource={dataSource} columns={COLUMNS} pagination={false} scroll={{ x: '100%' }} {...props} />;
};

export default SupplierLicensesTable;
